import { DEFAULT_LANGUAGE } from '../config/LanguageConfig'
import { syncDatePickerLocale } from '../config/DatePickerLocale'
import { STORAGE_LANGUAGE } from '../config/StorageConfig'
import messages from '../locales'
import { getStorage, setStorage } from './StorageService'

const getStoredLanguage = () => {
    const stored = getStorage(STORAGE_LANGUAGE)
    return stored && messages[stored] ? stored : DEFAULT_LANGUAGE
}

let currentLocale = getStoredLanguage()

const resolveKey = (obj, key) => {
    return key.split('.').reduce((acc, part) => (acc && acc[part] !== undefined ? acc[part] : undefined), obj)
}

const interpolate = (template, params) => {
    if (!params) {
        return template
    }
    return template.replace(/\{\{(\w+)\}\}/g, (_, name) => (params[name] !== undefined ? params[name] : ''))
}

const getLanguage = () => currentLocale

const setLanguage = (code) => {
    if (!messages[code]) {
        return
    }
    currentLocale = code
    setStorage(STORAGE_LANGUAGE, code)
    document.documentElement.lang = code
    syncDatePickerLocale(code)
    window.dispatchEvent(new CustomEvent('languagechange', { detail: { locale: code } }))
}

const t = (key, params) => {
    const value = resolveKey(messages[currentLocale], key)
    if (value === undefined) {
        const fallback = resolveKey(messages[DEFAULT_LANGUAGE], key)
        return typeof fallback === 'string' ? interpolate(fallback, params) : key
    }
    return typeof value === 'string' ? interpolate(value, params) : key
}

const initLanguage = () => {
    currentLocale = getStoredLanguage()
    document.documentElement.lang = currentLocale
    syncDatePickerLocale(currentLocale)
}

export { getLanguage, setLanguage, t, initLanguage }
